"use client";

import { useTranslations } from "next-intl";

import { useAuthGate } from "@/app/providers/AuthGateProvider";
import { Button } from "@/components/ui/button";
import { useRouter } from "@/i18n/navigation";

export function NewRecipeButton() {
  const t = useTranslations("recipes");
  const { requireAuth } = useAuthGate();
  const router = useRouter();

  return (
    <Button
      size="sm"
      onClick={() => {
        if (requireAuth()) router.push("/recipes/new");
      }}
    >
      {t("newRecipe")}
    </Button>
  );
}
